// extracted by mini-css-extract-plugin
module.exports = {"component":"GameTimer_component_3EhBn","clockIcon":"GameTimer_clockIcon_2LZ91","text":"GameTimer_text_2T02Y"};